import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { featureStateHooks } from '../../hooks/featureStateHooks/featureStateHooks';
import { languageHooks } from '../../hooks/languageHooks/languageHooks';
import { serverUtils } from '../../utils/serverUtils/serverUtils';
import { DataAttributes, LinkTarget } from '../Link/Link';

export type Props = {
  children: JSX.Element;
  className?: string;
  dataAttributes?: DataAttributes;
  isAnchorLink?: boolean;
  onClick?: React.MouseEventHandler;
  target?: LinkTarget;
  to: string | (() => string);
};

export const HrefLink = React.memo((props: Props) => {
  const {
    children,
    className,
    dataAttributes,
    isAnchorLink,
    to,
    target,
    onClick,
  } = props;

  const href = typeof to === 'string' ? to : to();
  const ref = React.useRef<HTMLAnchorElement>(null);

  const { isAnchorLink: isAnchorLinkOn } = featureStateHooks.useFeatureToggles();
  const path = languageHooks.useGetLanguageLink(href);

  if (isAnchorLink || isAnchorLinkOn) {
    return (
      <a
        className={className}
        href={path}
        target={target || LinkTarget.Self}
        onClick={onClick}
        ref={ref}
        {...dataAttributes}
      >
        {children}
      </a>
    );
  }

  return serverUtils.isNextBuild() ? (
    <a
      className={className}
      href={path}
      target={target || LinkTarget.Self}
      onClick={onClick}
      ref={ref}
      {...dataAttributes}
    >
      {children}
    </a>
  ) : (
    <RouterLink
      className={className}
      to={path}
      target={target || LinkTarget.Self}
      onClick={onClick}
      {...dataAttributes}
    >
      {children}
    </RouterLink>
  );
});

HrefLink.displayName = 'HrefLink';
